<template>
    <div class="pcr-sql-admin">
        <el-tabs type="border-card" @tab-click="tabClick" :value="$store.state.activeTab['system-sql']">
            <el-tab-pane label="Requêtes" name="Query">
                <el-input placeholder="Recherche" v-model="filterText" class="table-search"></el-input>
                <el-table 
                    ref="table" 
                    :data="searchFilteredQueries" 
                    :default-sort="{prop: 'QueryId', order: 'ascending'}" 
                    @current-change="currentChange"
                    style="width: 100%" 
                    highlight-current-row
                    border>
                    <el-table-column prop="QueryId" label="Id" sortable width="80px"></el-table-column>
                    <el-table-column prop="Name" label="Nom" sortable></el-table-column>
                    <el-table-column label="" width="84px" class-name="cell-action">
                        <template slot-scope="scope">
                            <el-dropdown trigger="click">
                                <el-button @click.stop>Actions <i class="fa fa-caret-down" aria-hidden="true"></i></el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="Edition" name="Edition">
                <div class="tab-contextual-button">
                    <el-tooltip placement="top" content="Ajouter une requête" effect="light" :open-delay="300" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                        <el-button @click="newQuery">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </el-button>
                    </el-tooltip>
                </div>

                <ck-form ref='ck-form' label-position="top">
                    <el-row :gutter="12">
                        <el-col :span="24">
                            <ck-form-item label="Nom" :display="currentQuery.Name">
                                <el-input v-model="currentQuery.Name" auto-complete="off" type="text"></el-input>
                            </ck-form-item>
                        </el-col>
                    </el-row>
                    
                    <el-row :gutter="12">
                        <el-col :span="24">
                            <ck-form-item label="Description" :display="$linebreakToBR(currentQuery.Description)">
                                <el-input v-model="currentQuery.Description" auto-complete="off" type="textarea" autosize></el-input>
                            </ck-form-item>
                        </el-col>
                    </el-row>

                    <h4>Paramètres</h4>
                    <el-row :gutter="12" v-for="(value,index) in currentQuery.Parameters">
                        <el-col :span="3">
                            <ck-informations label="Type" display="Custom" style="min-height: 56px;" v-if="value.ParameterType == 1"></ck-informations>
                            <ck-informations label="Type" display="UserId" style="min-height: 56px;" v-if="value.ParameterType == 2"></ck-informations>
                            <ck-informations label="Type" display="EstablishmentId" style="min-height: 56px;" v-if="value.ParameterType == 3"></ck-informations>
                        </el-col>
                        <el-col :span="3">
                            <ck-form-item label="Nom" :display="value.Name">
                                <el-input v-model="value.Name" auto-complete="off" type="text"></el-input>
                            </ck-form-item>
                        </el-col>
                        <el-col :span="3">
                            <ck-form-item label="Variable" :display="value.VariableName">
                                <el-input v-model="value.VariableName" auto-complete="off" type="text"></el-input>
                            </ck-form-item>
                        </el-col>
                        <el-col :span="8">
                            <ck-form-item label="Description" :display="value.Description">
                                <el-input v-model="value.Description" auto-complete="off" type="textarea" autosize></el-input>
                            </ck-form-item>
                        </el-col>
                        <el-col :span="3">
                            <ck-form-item label="SqlType" :display="value.SqlType">
                                <el-select v-model="value.SqlType" placeholder="Select" :readonly="value.ParameterType != 1">
                                    <el-option
                                        v-for="item in sqlTypes"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </ck-form-item>
                        </el-col>
                        <el-col :span="3">
                            <ck-form-item label="SelectionType" :display="value.SelectionType">
                                <el-select v-model="value.SelectionType" placeholder="Select">
                                    <el-option
                                        v-for="item in selectionTypes(value)"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </ck-form-item>
                        </el-col>
                        <el-col :span="1">
                            <el-button style="margin-top: 30px;" @click="deleteParameter(index)">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </el-button>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <div style="padding: 8px; margin-top: -8px;"><el-button type="primary" @click="addParameter" style="width: 100%;">Ajouter un paramètre</el-button></div>
                        </el-col>
                    </el-row>
                    
                    <h4>Codes</h4>
                    <codemirror v-model="currentQuery.Query" :options="editorOptions"></codemirror>
        
                    <div style="margin-top: 12px;">
                        <el-button type="default" @click="cancel" v-if="!currentQuery.QueryId">Annuler</el-button>
                        <el-button type="danger" @click="deleteQuery" v-if="currentQuery.QueryId">Supprimer</el-button>

                        <div class="pull-right">
                            <el-button type="default" @click="preview">Preview</el-button>
                            <el-button type="primary" @click.prevent="save" native-type="submit">
                                <span v-if="currentQuery.QueryId">Mettre à jour</span>
                                <span v-if="!currentQuery.QueryId">Enregistrer</span>
                            </el-button>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </ck-form>
            </el-tab-pane>
            <el-tab-pane 
                label="Execution" 
                name="Execute"
                v-loading="loading"
                element-loading-text="Loading...">
                <div v-if="!currentQuery.Query">
                    <h4>Veuillez sélectionner une requête</h4>
                </div>

                <div v-if="currentQuery.Query">
                    <h4>Paramètres</h4>
                    <ck-form ref='ck-execution-form' label-position="top">
                        
                        <div v-if="!currentQuery.Parameters.length" style="text-align: center;">
                            Aucun paramètre disponible
                        </div>
                        <el-row :gutter="12" v-for="(value,index) in currentQuery.Parameters">
                            <el-col :span="6">
                                <ck-informations label="Nom" :display="value.Name" style="min-height: 56px;"></ck-informations>
                            </el-col>
                            <el-col :span="10">
                                <ck-informations label="Description" :display="value.Description" style="min-height: 56px;"></ck-informations>
                            </el-col>
                            <el-col :span="8">
                                <div v-if="value.SelectionType == 3"> <!-- free -->
                                    <ck-form-item label="Valeur" :display="value.Value">
                                        <el-input v-model="value.Value" auto-complete="off" type="text"></el-input>
                                    </ck-form-item>
                                </div>
                            </el-col>
                        </el-row>
                        
                        <div style="margin-top: 12px;">
                            <div class="pull-right">
                                <el-button type="primary" @click.prevent="downloadCsv">
                                    Télécharger le csv
                                </el-button>
                                <el-button type="primary" @click.prevent="execute">
                                    Executer
                                </el-button>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </ck-form>

                    <div v-if="queryResult.Data.length">
                        <h4>Résultats</h4>
                        <el-row>
                            <el-col :span="24">
                                <el-pagination @size-change="handleSizeChange"
                                                @current-change="handleCurrentChange"
                                                :current-page="displayedPageNumber"
                                                :page-sizes="[10, 20, 50, 100, 'Tout']"
                                                :page-size="currentQuery.Pager.PerPage"
                                                layout="sizes, prev, pager, next"
                                                :total="queryResult.TotalCount">
                                </el-pagination>
                                <el-input placeholder="Recherche" v-model="filterExecutionText" class="table-search"></el-input>
                                <el-table 
                                    ref="table" 
                                    :data="queryResult.Data" 
                                    border 
                                    style="width: 100%; max-height: 600px; overflow-y: auto;" 
                                    highlight-current-row 
                                    @current-change="currentChange">
                                    <el-table-column v-for="(value,index) in queryResult.Properties" :key="index" :label="value" sortable>
                                        <template slot-scope="scope">
                                            {{ formatField(scope.row[index]) }}
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-pagination @size-change="handleSizeChange"
                                                @current-change="handleCurrentChange"
                                                :current-page="displayedPageNumber"
                                                :page-sizes="[10, 20, 50, 100, 'Tout']"
                                                :page-size="currentQuery.Pager.PerPage"
                                                layout="sizes, prev, pager, next"
                                                :total="queryResult.TotalCount">
                                </el-pagination>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Vue from 'vue';

// require active-line.js
require('codemirror/addon/selection/active-line.js')
// styleSelectedText
require('codemirror/addon/selection/mark-selection.js')
require('codemirror/addon/search/searchcursor.js')
// hint
require('codemirror/addon/hint/show-hint.js')
require('codemirror/addon/hint/show-hint.css')
require('codemirror/addon/hint/javascript-hint.js')
require('codemirror/addon/selection/active-line.js')
// highlightSelectionMatches
require('codemirror/addon/scroll/annotatescrollbar.js')
require('codemirror/addon/search/matchesonscrollbar.js')
require('codemirror/addon/search/searchcursor.js')
require('codemirror/addon/search/match-highlighter.js')
// keyMap
require('codemirror/mode/clike/clike.js')
require('codemirror/addon/edit/matchbrackets.js')
require('codemirror/addon/comment/comment.js')
require('codemirror/addon/dialog/dialog.js')
require('codemirror/addon/dialog/dialog.css')
require('codemirror/addon/search/searchcursor.js')
require('codemirror/addon/search/search.js')
require('codemirror/keymap/sublime.js')
// foldGutter
require('codemirror/addon/fold/foldgutter.css')
require('codemirror/addon/fold/brace-fold.js')
require('codemirror/addon/fold/comment-fold.js')
require('codemirror/addon/fold/foldcode.js')
require('codemirror/addon/fold/foldgutter.js')
require('codemirror/addon/fold/indent-fold.js')
require('codemirror/addon/fold/markdown-fold.js')
require('codemirror/addon/fold/xml-fold.js')

export default Vue.component('system-sql-admin', {
    props: {
    },
    data() {
        return {
            queries: [],
            filterText: '',
            filterExecutionText: '',
            currentQueryId: undefined,
            currentQuery: {
                QueryId: 0,
                Name: '',
                Description: '',
                Query: '',
                Parameters: [],
                Pager: {
                    Page: 0,
                    PerPage: 100,
                    Filters: [],
                    OrderBy: '',
                    OrderDesc: false
                }
            },
            queryResult: {
                Data: [],
                Properties: []
            },
            loading: false,

            editorOptions: {
                tabSize: 4,
                styleActiveLine: true,
                lineNumbers: true,
                line: true,
                foldGutter: true,
                styleSelectedText: true,
                gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
                highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
                mode: 'Text/X-Mysql',
                // hint.js options
                hintOptions: {
                    // 当匹配只有一项的时候是否自动补全
                    completeSingle: false
                },
                //快捷键 可提供三种模式 sublime、emacs、vim
                keyMap: "sublime",
                matchBrackets: true,
                showCursorWhenSelecting: true,
                theme: "rubyblue",
                extraKeys: { "Ctrl": "autocomplete" }
            },

            sqlTypes: [
                {label: 'BigInt', value: 'BigInt'},
                {label: 'Binary', value: 'Binary'},
                {label: 'Bit', value: 'Bit'},
                {label: 'Char', value: 'Char'},
                {label: 'Date', value: 'Date'},
                {label: 'DateTime', value: 'DateTime'},
                {label: 'DateTime2', value: 'DateTime2'},
                {label: 'DateTimeOffset', value: 'DateTimeOffset'},
                {label: 'Decimal', value: 'Decimal'},
                {label: 'Float', value: 'Float'},
                {label: 'Image', value: 'Image'},
                {label: 'Int', value: 'Int'},
                {label: 'Money', value: 'Money'},
                {label: 'NChar', value: 'NChar'},
                {label: 'NText', value: 'NText'},
                {label: 'NVarChar', value: 'NVarChar'},
                {label: 'Real', value: 'Real'},
                {label: 'UniqueIdentifier', value: 'UniqueIdentifier'},
                {label: 'SmallDateTime', value: 'SmallDateTime'},
                {label: 'SmallInt', value: 'SmallInt'},
                {label: 'SmallMoney', value: 'SmallMoney'},
                {label: 'Structured', value: 'Structured'},
                {label: 'Text', value: 'Text'},
                {label: 'Time', value: 'Time'},
                {label: 'Timestamp', value: 'Timestamp'},
                {label: 'TinyInt', value: 'TinyInt'},
                {label: 'Udt', value: 'Udt'},
                {label: 'VarBinary', value: 'VarBinary'},
                {label: 'VarChar', value: 'VarChar'},
                {label: 'Variant', value: 'Variant'},
                {label: 'Xml', value: 'Xml'},
            ]
        }
    },
    computed: {
        searchFilteredQueries() {
            if (!this.filterText) return this.queries;

            return _.filter(this.queries, (item) => {
                return _.includes(this.$normalizeString(item.Name), this.filterText)
                    || _.includes(this.$normalizeString(item.QueryId), this.filterText);
            });
        },
        displayedPageNumber() {
            return this.currentQuery.Pager.Page + 1;
        }
    },
    mounted: function () {
        this.refresh();
    },
    methods: {
        refresh() {
            if (!this.refreshing) {
                this.refreshing = true;

                this.$http.get('/api/system/queries').then((response) => {
                    this.queries = response.data;
                    this.refreshing = false;
                });

                this.currentQueryId = this.$router.currentRoute.query.queryId;

                if (this.currentQueryId) {
                    this.$http.get(`/api/system/query/${this.currentQueryId}`).then((response) => {
                        this.currentQuery.length = 0;

                        _.merge(this.currentQuery, response.data);

                        this.$store.state.activeTab['system-sql'] = 'Edition';
                    });
                }
            }
        },
        formatField(val) {
            if(_.startsWith(val, '/Date(')) {
                return this.$humanize(val, true);
            }

            return val;
        },
        handleSizeChange(val) {
            this.currentQuery.Pager.PerPage = isNaN(val) ? this.queryResult.TotalCount : val;
            console.log('this.currentQuery.Pager.PerPage', this.currentQuery.Pager.PerPage)
            this.execute();
        },
        handleCurrentChange(val) {
            this.currentQuery.Pager.Page = val - 1;
            this.execute();
        },
        selectionTypes(parameter) {
            var selection = [
                //not supported now
                // {
                //     value: 2,
                //     label: 'Selectable'
                // }, 
                {
                    value: 3,
                    label: 'Free'
                }]

            if (parameter.ParameterType != 1) {
                selection.push({
                    value: 1,
                    label: 'Executor'
                });
            }
            return selection;
        },
        tabClick(tab) {
            this.$store.commit('setActiveTab', { type: "system-sql", name: tab.name });
        },
        deleteParameter(index) {
            this.$swal({
                type: 'warning',
                title: 'Supprimer',
                html: `Etes-vous sûr de vouloir supprimer le paramètre ${this.currentQuery.Parameters[index].VariableName}.`,
                showCancelButton: true,
                confirmButtonClass: 'PCR-swal-btn el-button--danger',
                confirmButtonText: 'Supprimer',
                cancelButtonText: 'Annuler'
            }).then(() => {
                this.$swal({
                    type: 'success',
                    title: 'Supprimé !',
                    text: `${this.currentQuery.Name} a bien été supprimé.`
                }).then(() => {});
                
                this.currentQuery.Parameters.splice(index, 1);
            });
        },
        currentChange(row) {
            if (row) {
                if (this.$getSelectedText()) {
                    this.$refs['table'].setCurrentRow();
                    return;
                }

                let query = _.cloneDeep(this.$router.currentRoute.query);

                if (query.SQLAdmin) {
                    this.currentQueryId = row.QueryId;

                    query.queryId = this.currentQueryId;

                    this.$router.push({ query: query });
                }
            }
        },
        newQuery() {
            this.$swal({
                type: 'warning',
                title: 'Nouvelle requête',
                html: `Veuillez nommer votre nouvelle requête.`,
                showCancelButton: true,
                // confirmButtonClass: 'PCR-swal-btn el-button--danger',
                confirmButtonText: 'Comfimer',
                cancelButtonText: 'Annuler',
                input: 'text',
            }).then((inputValue) => {
                console.log('inputValue', inputValue)
                this.currentQueryId = undefined;
                this.currentQuery = {
                    Name: inputValue,
                    Description: '',
                    Query: ''
                }
                this.save();
            });
        },
        deleteQuery() {
            this.$swal({
                type: 'warning',
                title: 'Supprimer',
                html: `<b>Vous êtes sur le point de supprimer ${this.currentQuery.Name}.</b><br /><br />Veuillez entrer le terme "<b>effacer</b>" pour confirmer cette suppresion.`,
                input: 'text',
                showCancelButton: true,
                confirmButtonClass: 'PCR-swal-btn el-button--danger',
                confirmButtonText: 'Supprimer',
                cancelButtonText: 'Annuler',
                preConfirm: function (inputValue) {
                    return new Promise(function (resolve, reject) {
                        if (inputValue.toLowerCase() === 'effacer') {
                            resolve();
                        } else {
                            reject('Valeur incorrecte');
                        }
                    });
                }
            }).then(() => {
                this.$http.delete(`/api/system/query/${this.currentQuery.QueryId}`)
                    .then((response) => {
                        this.$swal({
                            type: 'success',
                            title: 'Supprimé !',
                            text: `${this.currentQuery.Name} a bien été supprimé.`
                        }).then(() => {});
                        
                        this.refresh();

                    }, this.$defaultSwalApiResponse );
            });
        },
        cancel() {
            this.currentQuery = {
                QueryId: 0,
                Name: '',
                Description: '',
                Query: '',
                Parameters: []
            }
        },
        preview() {
            this.$store.state.activeTab['system-sql'] = 'Execute';
        },
        execute() {
            this.loading = true;
            this.$http.post(`/api/system/query/execute`, { query: this.currentQuery }).then((response) => {
                if (response.data.Error) {
                    this.$swal({
                        type: 'error',
                        title: 'Erreur',
                        html: response.data.Error.InnerException.Message
                    }).then();
                }
                else {
                    this.queryResult = response.data;
                }

                this.loading = false;
            }, (response) => {
                this.$defaultSwalApiResponse(response);
                this.loading = false;
            });
        },
        downloadCsv() {
            this.$http.post(`/api/system/query/csv`, { query: this.currentQuery }).then((response) => {
                let d = new Date();

                let month = String(d.getMonth() + 1);
                let day = String(d.getDate());
                let year = String(d.getFullYear());

                window.location.href = `/api/system/temp?guid=${response.data}&name=${this.currentQuery.Name + '-' + year + month + day}`;
            });
        },
        save() {
            console.log('this.currentQuery', this.currentQuery)
            this.$http.post(`/api/system/query`, this.currentQuery).then((response) => {
                this.currentQuery.QueryId = response.data;
                this.refresh();

                this.$swal({
                    type: 'success',
                    title: 'Sauvegarder',
                    html: `La requête a bien été enregistrée`
                }).then();
            });
        },
        addParameter() {
            this.$swal({
                title: 'Ajouter un paramètre',
                html: `Sélectionné le paramètre que vous souhaitez ajouter`,
                input: 'select',
                inputOptions: {
                    1: 'Custom',
                    //2: 'UserId',
                    //3: 'EstablishmentId'
                }
            }).then((result) => {
                this.currentQuery.Parameters.push({
                    Name: '',
                    VariableName: '',
                    Description: '',
                    SqlType: result != 1 ? 'int' : '',
                    SelectionType: 3,
                    ParameterType: result
                });
            });
        }
    },
    watch: {
        currentQueryId() {
            this.refresh();
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/system/system-sql-admin.vue